import React, { useState, useEffect } from "react";
import { get } from "lodash";
import { UserTracking as tracking, UserFlowIds } from "@irati-tracking/onboarding";
import History from "@irati/utils/history";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { withTheme } from "styled-components";
import customisationService from "@irati/onboarding/services/customisation";
import { H2, Body } from "@irati/ui/src/Typography";
import Spacing from "@irati/ui/src/Spacing";
import { BannerWrapper, TextWrapper, ButtonWrapper, StyledButton, StyledPill, StyledClose } from "./styled";
import CloseBannerModal from "./CloseBannerModal";
var CustomisationBanner = function (_a) {
    var user = _a.user, metadata = _a.metadata, suggestions = _a.suggestions;
    var _b = useState(null), showBanner = _b[0], setShowBanner = _b[1];
    var _c = useState(false), showModal = _c[0], setShowModal = _c[1];
    useEffect(function () {
        var favouriteCategories = get(metadata || {}, "config.favouriteCategories");
        if (favouriteCategories && favouriteCategories.length > 0) {
            setShowBanner(false);
            return;
        }
        var shouldShowBanner = function () {
            return customisationService.shouldShowCategoriesBanner(user).then(function (shouldShowCategoriesBanner) {
                setShowBanner(shouldShowCategoriesBanner);
            });
        };
        shouldShowBanner();
    }, []);
    var onClickClose = function () {
        tracking.bannerDismissed({
            flow: UserFlowIds.CategoriesCustomisation
        });
        setShowModal(true);
    };
    var hideBanner = function () {
        tracking.modalButtonClicked({
            flow: UserFlowIds.CategoriesCustomisation
        });
        customisationService.dismissCategoriesBanner(user);
        setShowBanner(false);
        setShowModal(false);
    };
    var buttonClicked = function () {
        tracking.bannerButtonClicked({
            flow: UserFlowIds.CategoriesCustomisation
        });
        History.push("/account/settings/customisation/categories");
    };
    var linkClicked = function () {
        tracking.modalLinkClicked({
            flow: UserFlowIds.CategoriesCustomisation
        });
        History.push("/account/settings/customisation/categories");
    };
    if (!showBanner)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(BannerWrapper, null,
            React.createElement(TextWrapper, null,
                React.createElement(H2, { marginBottom: 1 },
                    React.createElement(FormattedMessage, { id: "perks.containers.homepage.customisation.customisationHeader" })),
                React.createElement(Body, null,
                    React.createElement(FormattedMessage, { id: "perks.containers.homepage.customisation.description" })),
                React.createElement(Spacing, { marginTop: 2, marginBottom: -1 }, suggestions.map(function (name) {
                    return React.createElement(StyledPill, { key: name }, name);
                }))),
            React.createElement(ButtonWrapper, null,
                React.createElement(StyledButton, { full: true, primary: true, onClick: buttonClicked },
                    React.createElement(FormattedMessage, { id: "perks.containers.homepage.customisation.buttonLabel" }))),
            React.createElement(StyledClose, { onClick: onClickClose })),
        showModal && React.createElement(CloseBannerModal, { onCloseModal: hideBanner, onLinkClicked: linkClicked })));
};
export default injectIntl(withTheme(CustomisationBanner));
